import { render, staticRenderFns } from "./AddLiveRoleForm.vue?vue&type=template&id=120e433c"
import script from "./AddLiveRoleForm.vue?vue&type=script&lang=js"
export * from "./AddLiveRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports